import { useExternalLocationAirQuality, AirQualityThresholds, getTimestampFormat } from 'common';
import { useEffect, useState } from 'react';
import { gradients } from 'tamagui-config/src/tokens';

import { QualityData } from './useInternalAirQualityData';
import { useAppSync } from '../../contexts/AppSyncContext';

export const useExternalAirQualityData = () => {
  const [qualityData, setQualityData] = useState<QualityData>({
    airQualityLabel: 'Good',
    gradientColors: gradients.success,
    value: 0,
    timestamp: getTimestampFormat(),
  });

  const { hub } = useAppSync();
  const { externalAirQuality: externalAirQualityData } = useExternalLocationAirQuality(
    hub?.latitude,
    hub?.longitude,
  );

  const getOutdoorQualityData = (value: number): QualityData => {
    const { good: GOOD_THRESHOLD, moderate: MODERATE_THRESHOLD } = AirQualityThresholds.eaq;

    let airQualityLabel = '';
    let gradientColors = gradients.success;
    const timestamp = getTimestampFormat();

    if (value <= GOOD_THRESHOLD) {
      airQualityLabel = 'Good';
      gradientColors = gradients.success;
    } else if (value <= MODERATE_THRESHOLD) {
      airQualityLabel = 'Moderate';
      gradientColors = gradients.warning;
    } else {
      airQualityLabel = 'Unhealthy';
      gradientColors = gradients.error;
    }

    return {
      value,
      airQualityLabel,
      gradientColors,
      timestamp,
    };
  };

  useEffect(() => {
    const aqi = externalAirQualityData?.universalAqi?.aqi || 0;
    const outdoorQualityData = getOutdoorQualityData(aqi);
    setQualityData(outdoorQualityData);
  }, [externalAirQualityData]);

  return {
    qualityData,
  };
};
